export default {
  apiKey: process.env.VUE_APP_ZENDESK_WEB_WIDGET_API_KEY
}
